import { useState, useEffect, useRef } from "react";
export default function FooterContact() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="bg-background text-foreground w-full">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Mono:wght@400;500&family=Inter:wght@300;400;500&display=swap');`}</style>

      <div className={`transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="bg-muted/40 px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground tracking-widest uppercase" style={{
          fontFamily: "'DM Mono', monospace"
        }}>
            © Copyright 2015 FABCO LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-1">
            <div className="w-1.5 h-1.5 rounded-lg bg-primary opacity-70" />
            <div className="w-1.5 h-1.5 rounded-lg bg-primary opacity-40" />
            <div className="w-1.5 h-1.5 rounded-lg bg-primary opacity-20" />
          </div>
        </div>
      </div>
    </section>;
}